import React, { useEffect, useState } from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import styles from './Toast.module.scss';

const Toast = ({ show, type, message, duration, onClose, position }) => {
  const [isVisible, setIsVisible] = useState(show);

  useEffect(() => {
    setIsVisible(show);
    if (show && duration > 0) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        if (onClose) onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [show, duration, onClose]);

  if (!isVisible) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <i className='icon-check-mark' />;
      case 'error':
        return <i className='icon-cross-x' />;
      case 'loading':
        return <i className='icon-loading icon-spin' />;
      case 'warning':
        return <i className='icon-alert-triangle' />;
      case 'info':
      default:
        return <i className='icon-notification' />;
    }
  };

  return (
    <div className={cx(styles.toastContainer, styles[position])}>
      <div className={cx(styles.toast, styles[type], 'animated fadeInRight')}>
        <div className={styles.iconWrapper}>{getIcon()}</div>
        <div className={styles.message}>{message}</div>
        {type !== 'loading' && (
          <button
            type='button'
            className={styles.closeButton}
            onClick={() => {
              setIsVisible(false);
              if (onClose) onClose();
            }}
          >
            <i className='icon-cross-x' />
          </button>
        )}
      </div>
    </div>
  );
};

Toast.propTypes = {
  show: PropTypes.bool.isRequired,
  type: PropTypes.oneOf(['success', 'error', 'warning', 'info', 'loading']),
  message: PropTypes.string.isRequired,
  duration: PropTypes.number,
  onClose: PropTypes.func,
  position: PropTypes.oneOf(['topRight', 'topLeft', 'bottomRight', 'bottomLeft']),
};

Toast.defaultProps = {
  type: 'info',
  duration: 3000,
  onClose: null,
  position: 'bottomRight',
};

export default Toast;
